/**
 * Hook для получения WABA templates (TODO-027a)
 * Дата: 15.01.2026
 *
 * СВЯЗАННЫЕ МОДУЛИ И ФАЙЛЫ:
 * - `frontend/src/api/waba.ts` — HTTP вызовы
 * - `frontend/src/components/features/messages/WABATemplatePicker.tsx` — UI выбора шаблонов
 *
 * СХЕМА:
 * - Композиция функций:
 *   - useWABATemplates -> react-query -> wabaApi.getTemplates
 */
import { useQuery } from '@tanstack/react-query';
import { wabaApi } from '@/api/waba';

export function useWABATemplates(tenantId?: string) {
  return useQuery({
    queryKey: ['waba-templates', tenantId],
    queryFn: () => wabaApi.getTemplates(tenantId),
    enabled: !!tenantId,
    staleTime: 60_000,
  });
}

